/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEnrichedInstrumentLinkRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetEnrichedInstrumentLink.pb'
import {GetEnrichedInstrumentLinkResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetEnrichedInstrumentLink.pb'


export const getEnrichedInstrumentLink = (request: GetEnrichedInstrumentLinkRequest, options?: CashRequestOptions) => post<GetEnrichedInstrumentLinkRequest, GetEnrichedInstrumentLinkResponse>("/2.0/cash/get-enriched-instrument-link", request, {...options, rejectOnError: true })